import { ArrowDropDown } from '@mui/icons-material';
import { Menu, styled } from '@mui/material';
import { Grid } from '@mui/system';

const StyledGridContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const StyledButtonBadge = styled('button')(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  borderRadius: '0.25rem',
  border: 'none',
  padding: '0.225rem 0.225rem 0.225rem 0.5rem',
  marginTop: '0.375rem',
  cursor: 'pointer',
  outline: 'none',
  width: 'auto',
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'auto',
}));

const StyledArrowDropDown = styled(ArrowDropDown)(() => ({
  marginLeft: '0.25rem',
  fontSize: '1.25rem',
}));

const StyledMenuList = styled(Menu)(() => ({
  '& .MuiMenu-list': {
    padding: '0.5rem',
  },
}));

export { StyledGridContainer, StyledButtonBadge, StyledArrowDropDown, StyledMenuList };
